module.exports = __webpack_public_path__ + "img/Omkar.bf022c01.jpeg";